import { render, staticRenderFns } from "./opera.vue?vue&type=template&id=332a1ba5&lang=html&"
import script from "./opera.vue?vue&type=script&lang=js&"
export * from "./opera.vue?vue&type=script&lang=js&"
import style0 from "./opera.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "opera.vue"
export default component.exports